import React, {useRef} from "react"
import {useTranslation} from "react-i18next";

import {CListGroup, CListGroupItem, CToast, CToastBody, CToaster, CToastHeader} from "@coreui/react-pro"

import DateAgoHelper from "@asset/DateAgoHelper"
import PropTypes from "prop-types"

const ErrorWrapper = ({message, error}) => {
    const {t} = useTranslation()

    const toaster = useRef()

    const messObj = (
        typeof message === "string" ?
            message
            :
            Object.keys(message).map(name => {
                return message[name].map(value => {
                    return <li key={name}>{value}</li>
                })
            })
    )

    const errorLoggedToast = (
        <CToast title={t('error.title')}>
            <CToastHeader closeButton>
                <svg
                    className="rounded me-2"
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                    role="img"
                >
                    <rect width="100%" height="100%" fill="#007aff"></rect>
                </svg>
                <strong className="me-auto">{t('error.message')}</strong>
                <small>
                    <DateAgoHelper/>
                </small>
            </CToastHeader>
            <CToastBody>
                {typeof (messObj) === 'string' ?
                    messObj : <ul>{messObj}</ul>
                }
                {error?.exception ?
                    <div className="mt-2 pt-2 border-top">
                        <CListGroup>
                            <CListGroupItem>
                                <strong>Error: </strong> {error.exception}
                            </CListGroupItem>
                            <CListGroupItem>
                                <strong>File: </strong> {error.file}
                            </CListGroupItem>
                            <CListGroupItem>
                                <strong>Line: </strong> {error.line}
                            </CListGroupItem>
                        </CListGroup>
                    </div>
                    : null}
            </CToastBody>
        </CToast>
    )

    return (
        <>
            <CToaster ref={toaster} push={errorLoggedToast} placement="top-end"/>
        </>
    )
}

ErrorWrapper.propTypes = {
    message: PropTypes.any,
    error: PropTypes.any,
}

export default ErrorWrapper
